import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { FullPageCard } from "component/shared/full-page-card";
import { settingsSectionStyles as styles } from "./styles";

interface Props extends WithStyles<typeof styles> {
	title: string;
	/** Id for the title, so a control inside can name it with aria-labelledby. */
	titleId?: string;
	description?: React.ReactNode;
	/** Constrain the body to the designs' 576px form column. */
	fieldColumn?: boolean;
	/** Space title, description and content 24px apart, as the MAX-4419 design kit does. */
	refreshed?: boolean;
	children?: React.ReactNode;
}

const Component: React.FC<Props> = ({
	title,
	titleId,
	description,
	fieldColumn = false,
	refreshed = false,
	children,
	classes = {},
}) => (
	<Mui.Box mb={2}>
		<FullPageCard>
			<Mui.Typography
				id={titleId}
				className={`${classes.sectionHeading} ${classes.sectionTitle}`}
			>
				{title}
			</Mui.Typography>
			{description && (
				<Mui.Typography className={`${classes.sectionDescription} ${refreshed ? classes.refreshedGap : ""}`}>
					{description}
				</Mui.Typography>
			)}
			{fieldColumn ? <Mui.Box className={classes.fieldColumn}>{children}</Mui.Box> : children}
		</FullPageCard>
	</Mui.Box>
);

export const SettingsSection = withStyles(Component, styles);
